
import { sync } from 'vuex-pathify'
export default {
    data: () => ({
        oPubTopic: null,
        oSubTopic: null,
        oInited: false
    }),
    computed: {
        oUser: sync('login/loggedinUser'),
        oMqttClient: sync ('mqtt/origMqttClient'),
        mqttClient: sync('mqtt/mqttClient'),
    },
    methods: {
        initBCScanner (callBack) {
            this.oPubTopic = this.oUser.org + '/scanreq/' + this.oUser.uid + '/0'
            this.oSubTopic = this.oUser.org + '/scanresp/' + this.oUser.uid + '/0'
            // this.oMqttClient.publish(this.oPubtopic, '{"msg": "scan now"}')
            console.log('pub, sub: ', this.oPubTopic, this.oSubTopic)
            var self = this
            this.oMqttClient.subscribe(this.oSubTopic, function (err) {
                if (err) console.log('mqtt subscribe error: ', err)
            })
            this.oMqttClient.on('message', function (topic, message, packet) {
                if (topic !== self.oSubTopic) return
                // console.log('RFID message received: topic: %s, message: %message', topic, message)
                try {
                    var resp = JSON.parse(message.toString())
                } catch (ex) {
                    console.log('parse exception: ', message.toString(), ex)
                }
                
                if (resp.status && resp.status === 'cancelled)') {
                    // self.oMqttClient.unsubscribe(topic)
                    return
                }
                if (resp.code !== undefined) {
                    // self.oMqttClient.unsubscribe(topic)
                    callBack(resp.code)
                }
            })
            this.oInited = true
            console.log('Initialized BC SCanner')
        },
        requestScan() {
            if (!this.oInited) {
                console.log('BCScanner not initialized')
                return
            }
            console.log('Sending message to topic ', this.oPubTopic)
            this.oMqttClient.publish(this.oPubTopic, '{"msg": "scan now"}')
        },
        endBCScanner () {
            this.oMqttClient.unsubscribe(this.oSubTopic)
        }
    }
}